'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { dataLayerPush, Events } from '@libs/analytics';
import { getENV } from '@libs/common-next';
import { BuyItAgainItem } from '@libs/common-types';
import { resolvePrice } from './resolve-price';
export function useTrackProduct(t0) {
  const $ = _c(9);
  const {
    product,
    onView
  } = t0;
  const t1 = !onView;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      triggerOnce: t1,
      threshold: 0.2
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    ref,
    inView
  } = useInView(t2);
  let t3;
  let t4;
  if ($[2] !== inView || $[3] !== onView || $[4] !== product) {
    t3 = () => {
      if (!inView) {
        return;
      }
      if (onView) {
        onView();
        return;
      }
      dataLayerPush({
        ecommerce: null
      });
      dataLayerPush({
        event: Events.VIEW_ITEM_LIST,
        ecommerce: {
          currency: getENV("NEXT_PUBLIC_LOCALE") === "en-CA" ? "CAD" : "USD",
          category: null,
          sub_category1: null,
          sub_category2: null,
          item: {
            item_name: product.name,
            item_id: product.webStyleId,
            price: resolvePrice(product.price),
            item_category: product.itemCategory ?? null,
            item_category2: product.itemCategory2 ?? null,
            item_category3: product.itemCategory3 ?? null,
            item_category4: product.itemCategory4 ?? null,
            item_category5: product.itemCategory5 ?? null,
            item_brand: product.brand ?? null,
            item_variant: product.sku,
            index: product.recommendationRank,
            item_list_name: "buy again",
            item_list_id: "standard plp",
            item_search_term: null
          }
        }
      });
    };
    t4 = [inView, product, onView];
    $[2] = inView;
    $[3] = onView;
    $[4] = product;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  let t5;
  if ($[7] !== ref) {
    t5 = {
      ref
    };
    $[7] = ref;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}